import * as ACTION from 'actions';

export function popup(state={show:false, title:'', text: ''}, action) {
    switch (action.type) {
        case ACTION.SHOW_POPUP:
            return action.popup;
        case ACTION.CLOSE_POPUP:
            return {...state, show: false}
        default:
            return state;
    }
}